import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import Header from '../components/Header';
import Hero from '../components/Hero';
import ContentSection from '../components/ContentSection';
import Footer from '../components/Footer';
import Mantra from '../components/Mantra';
import '../styles/App.css';
import HeroImage from '../assets/images/Mantra_2.png';
import MantraImage from '../assets/images/HeroCoach.png';

function VolleyballClubs() {
  const programDetails = {
    items: [
      {
        title: 'Your Landing Page',
        subtitle1: 'Built for You',
        body1: (
          <>
            <ul>
              <li>Get a unique club landing page to share with your athletes</li>
              <li>Players sign up through your link and join your roster</li>
              <li>Use it for recruiting, registration, and marketing your program</li>
            </ul>
          </>
        ),
        subtitle2: 'Pricing & Revenue',
        body2: (
          <>
            <ul>
              <li>Athletes get a discounted rate when they join through your club</li>
              <li>You set your own markup per athlete to create a revenue stream for your program</li>
              <li>Yearly membership—athletes re-up each year</li>
            </ul>
          </>
        ),
      },
    ],
  };

  return (
    <div className="home">
      <SEO
        title="For Volleyball Clubs & High School Programs"
        description="Offer the Begin Strength Volleyball Program to your athletes. Discounted pricing for your players, revenue for your club."
        image="/social-media-image.png"
        path="/clubs"
      />
      <Header />
      <main>
        <Hero
          backgroundImage={HeroImage}
          headerText={
            <>
              Club <span style={{ color: 'red' }}>Volleyball</span>
            </>
          }
          paragraphText={
            <>
              <p>
                Offer your athletes a strength program built for volleyball—vertical power, lateral explosion, and periodization around their seasons.
              </p>
              <p>
                Includes a public landing page, for player signup, and marketing.
              </p>
            </>
          }
          primaryButtonText="Create Account"
          primaryButtonLink="/signup?redirect=/clubs/signup"
        />
        <ContentSection
          items={programDetails.items}
          sectionClass="faq-sub-section"
          showNumbers={false}
        />
        <div className="cta-simple">
          <div className="cta-simple-content">
            <h2 className="cta-simple-title">
              Create a Revenue <span style={{ color: 'red' }}>Stream</span>
            </h2>
            <p className="cta-simple-description">
              We give the discount. You set the price. Your athletes get stronger and your club earns on every membership.
            </p>
            <Link to="/signup?redirect=/clubs/signup" className="c-ripple primary-button">
              Create Account
            </Link>
          </div>
        </div>
        <Mantra
          backgroundImage={MantraImage}
          mantraText="Seven Days Off makes One Weak"
        />
        <Footer />
      </main>
    </div>
  );
}

export default VolleyballClubs;
